import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Pages/Main/';
import Login from '@/components/Pages/Login';

Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '',
    name: 'Main',
    component: Main,
    redirect: '',
  },
];

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
